import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import {type IssueUpdateArgs, updateIssuesById} from '../relay-tsq-interop'
import type {
  updateIssueAssigneesBulkMutationSharedMutation,
  UpdateIssuesBulkInput,
} from './__generated__/updateIssueAssigneesBulkMutationSharedMutation.graphql'

export function commitUpdateIssueAssigneesBulkMutationSharedMutation({
  environment,
  optimisticUpdateIds,
  existingIssueAssignees,
  connectionIds,
  input: {ids, applyAssigneeIds, removeAssigneeIds},
  onCompleted,
  onError,
}: {
  environment: Environment
  connectionIds: {[key: string]: string[]}
  input: {ids: string[]} & IssueUpdateArgs
  optimisticUpdateIds: string[]
  existingIssueAssignees: Map<string, string[]>
  onCompleted?: (response: updateIssueAssigneesBulkMutationSharedMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {applyAssigneeIds, removeAssigneeIds}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  return commitMutation<updateIssueAssigneesBulkMutationSharedMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateIssueAssigneesBulkMutationSharedMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssuesById(store, optimisticUpdateIds, existingIssueAssignees, connectionIds, inputArgs),
    optimisticUpdater: store =>
      updateIssuesById(store, optimisticUpdateIds, existingIssueAssignees, connectionIds, inputArgs),
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
